import { LinearProgress, linearProgressClasses, styled } from "@mui/material";

export const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#4a5e6b',
  }
}))